import React from "react";

export const Footer = () => {
  return (
    <footer className="bg-[#09090B] text-white py-16">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-3 gap-10 items-end">
        <div>
          <div className="font-display text-2xl tracking-tighter">
            AKSHAY<span className="text-[#3B5BDC]">.</span>
          </div>
          <p className="mt-3 text-sm text-zinc-500 max-w-xs">
            Digital marketing built around your business, not a template.
          </p>
        </div>
        <div className="text-sm text-zinc-500">
          <p>06 / 06 — End of page</p>
        </div>
        <div className="text-sm text-zinc-500 md:text-right">
          © {new Date().getFullYear()} Akshay Salve. All rights reserved.
        </div>
      </div>
    </footer>
  );
};
